import { actionTypes } from "./actions";
import { v4 as uuid } from "uuid";

const initialState = {
    assetTypeId: 0,
    activeStep: 0,
    exclusionReasonDate: null,
    excludeAssets: [],
    excludeAssetsStep: 0,
    exclusionReasonTypeId: 0,
    notes: {
        content: "",
        createdDate: null,
        id: uuid(),
    },
    steps: [],
    photos: [],
    stepsCompleted: [],
};

export default function (state = { ...initialState }, action) {
    switch (action.type) {
        case actionTypes.DETAILS_CLEAR: {
            return initialState;
        }
        case actionTypes.DETAILS_SET: {
            const { details } = action.payload;
            return { ...state, ...details };
        }
        default: {
            return state;
        }
    }
}
